import { useEffect, useState } from 'react';
import styles from './DepositTab.module.css';
import DynamicTable from '../../../../components/DynamicTable/DynamicTable';
import ClickableButton from '../../../../components/ClickableButton/ClickableButton';
import CheckboxAndData from '../../../../components/CheckboxAndData/CheckboxAndData';
import { useDispatch } from 'react-redux';
import { openModal } from '../../../../redux/slices/modalSlice';
import { useLocation, useNavigate } from 'react-router';

const DepositTab = () => {
  const [tableData] = useState([]); // you can populate this dynamically later

  const location = useLocation();
  const navigate = useNavigate();

  const headings = [
    { title: <CheckboxAndData />, accessor: 'checkbox' },
    { title: 'Description', accessor: 'description' },
    { title: 'Amount', accessor: 'amount' },
    { title: 'Issued Against', accessor: 'issuedAgainst' },
    { title: 'Recorded By', accessor: 'recordedBy' },
    { title: 'Reason', accessor: 'reason' },
    { title: 'Category', accessor: 'category' },
  ];

  const dispatch = useDispatch();

  return (
    <div className={styles.DepositTab}>
      <div className={styles.buttonRow}>
        <ClickableButton
          label="Add Deposit"
          onClick={() => dispatch(openModal('addDepositBalance'))}
        />
        <ClickableButton
          label="Refund Deposit"
          onClick={() => dispatch(openModal('refundDeposit'))}
        />
        <ClickableButton
          label="Record Payment"
          onClick={() => navigate('/management/students/profile')}
        />
        <ClickableButton
          label="Transfer To Credit"
          onClick={() => dispatch(openModal('transferToCredit'))}
        />
        <ClickableButton label="Download Excel" />
      </div>

      <div className={styles.tableWrapper}>
        <DynamicTable headings={headings} columnData={tableData} />
      </div>
    </div>
  );
};

export default DepositTab;
